import { render } from "./WaterskiTips.vue?vue&type=template&id=fb0f2eb0&scoped=true"
import script from "./WaterskiTips.vue?vue&type=script&lang=js"
export * from "./WaterskiTips.vue?vue&type=script&lang=js"

import "./WaterskiTips.vue?vue&type=style&index=0&id=fb0f2eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0f2eb0"]])

export default __exports__